import React from 'react';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import SelectValue from './SelectValue';
import { refCreatePromise as refCreateSimplePromise } from '../simple.store';
import { refCreatePromise as refCreateComplexPromise } from '../../complex/product/store';
import { REF_PATH as PRODUCT_REF_PATH } from '../../complex/product/Const';
import { VERSIONS, CURRENT_RELEASE } from '@/util/version';
import { validateRoleConfig } from '../../../auth/RoleConfigFilter.jsx';
import './dictpicker.less'; // todo make css fit with the themes
import { handleFormChanged } from '@/store/allaround.store.js';
import OptionComponent from './MultiDictsOption';
import { sortedDict } from './DictPicker';
import { Button } from '../../../form/FormControls.jsx';
import filterOptions from '../../../../../node_modules/react-select/lib/utils/defaultFilterOptions';
import { Map, List } from 'immutable';

// we need to make fuzzy matching... want it here badly
export class MultiDictsPicker extends React.Component {
  constructor(props) {
    super(props);
    this.onInputChange = this.onInputChange.bind(this);
    this.filterOptions = this.filterOptions.bind(this);
    this.setValue = this.setValue.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onChange = this.onChange.bind(this);
    this.getDicts = this.getDicts.bind(this);
    this.addButtonDict = this.addButtonDict.bind(this);
    this.addButtonDictName = this.addButtonDictName.bind(this);
    this.enteredValue = '';
    this.state = {
      data: [],
      value: props.defaultValue ? props.defaultValue : '',
      showModal: false,
      errorMsg: '',
    };
  }

  componentWillMount() {
    if (this.state.value.toArray) {
      this.setState({ value: this.state.value.toArray() });
    }
    this.createData(this.props);
  }
  componentWillReceiveProps(props) {
    this.createData(props);
    if (this.props.clearOnDisabledSwitch && !!this.props.disabled != !!props.disabled) {
      this.setValue(undefined);
    }
  }

  onInputChange(val) {
    this.enteredValue = val;
  }

  onChange(value) {
    const complex = this.addButtonDict() == PRODUCT_REF_PATH;
    const refValue = value instanceof Array ? value[value.length - 1] : value;
    if (refValue != null && refValue.value == -1) {
      let refDto = undefined;
      if (complex) {
        refDto = {
          id: '',
          color: '#FFFFFF',
          productId: '',
          name: this.enteredValue,
          hidden: false,
        };
      } else {
        refDto = {
          name: this.enteredValue,
          hidden: false,
        };
        if (this.props.onBeforeAddDictValue) {
          refDto = this.props.onBeforeAddDictValue(refDto);
        }
      }

      if (complex) {
        refCreateComplexPromise(`/references/${this.addButtonDict()}/api`, refDto)
          .then((response) => {
            let refItem = undefined;

            if (complex) {
              refItem = {
                value: response.productTypes[0].id,
                label: response.name,
                product: response.id,
                disabled: false,
                hidden: false,
              };
            } else {
              refItem = {
                id: response.id,
                name: response.name,
                disabled: false,
                hidden: false,
              };
            }

            if (value instanceof Array) {
              const values = value;
              values[value.length - 1] = refItem;
              this.setValue(values);
            } else {
              this.setValue(refItem);
            }
            return true;
          })
          .catch((data) => {
            this.openModal(data.name);
            return false;
          });
      } else {
        refCreateSimplePromise(refDto, this.addButtonDict())
          .then((response) => {
            const refItem = {
              value: response.id,
              label: response.name,
              disabled: false,
              hidden: false,
            };
            if (value instanceof Array) {
              const values = value;
              values[value.length - 1] = refItem;
              this.setValue(values);
            } else {
              this.setValue(refItem);
            }
            return true;
          })
          .catch((data) => {
            this.openModal(data.name);
            return false;
          });
      }
    } else {
      this.setValue(value);
    }
  }

  getDicts(props = this.props) {
    return props.dicts
      ? props.dicts.replace(/\s/g, '').split(',')
      : [];
  }

  setValue(value) {
    this.setState({ value });
    if (this.props.onChangeFunc) {
      this.props.onChangeFunc(value);
    }
    if (this.props.handleFormChanged) {
      this.props.handleFormChanged();
    }
  }

  addButtonDict() {
    if (this.props.addButtonDict) {
      return typeof this.props.addButtonDict === 'string' ?
        this.props.addButtonDict : this.props.addButtonDict.path;
    }
    return undefined;
  }

  addButtonDictName() {
    if (this.props.addButtonDict) {
      return typeof this.props.addButtonDict === 'string' ?
        this.props.addButtonDict : this.props.addButtonDict.name;
    }
    return undefined;
  }

  filterOptions(options, filterValue, excludeOptions, params) {
    const value = filterValue ? filterValue.trim() : filterValue;
    let results = filterOptions == undefined
      ? options
      : filterOptions(options, value, excludeOptions, params);
    if (this.props.excludeData) {
      results = results.filter((item) => !this.props.excludeData.has(item.value));
    }
    if (this.props.filterFunc) {
      results = results.filter((item) => this.props.filterFunc(item));
    }
    if (CURRENT_RELEASE >= VERSIONS.Harmony && this.addButtonDict() && filterValue
      && validateRoleConfig(['references#2'])) {
      results.unshift({
        value: -1,
        label: 'Add new item',
        hidden: false,
        disabled: false,
        style: { color: 'white', backgroundColor: '#008cba', margin: '5px 0' },
      });
    }
    return results;
  }

  openModal(errorMsg) {
    this.setState({ showModal: true, errorMsg });
  }
  closeModal() {
    this.setState({ showModal: false });
  }

  createData(props) {
    let value = undefined;
    if (!props.isChanged || props.updateDefValueOnEveryChange) {
      value = props.defaultValue ? props.defaultValue : '';
      if (value.toArray) {
        value = value.toArray();
      }
    }
    if (props.simple) {
      let data = [];

      const dicts = this.getDicts(props);

      dicts.forEach((dict) => {
        const dictData = props.simple
          .get(dict, new List())
          .toJS()
          .map((elem) => {
            const newElem = {
              value: elem.id,
              label: elem.name,
              hidden: this.state.value !== elem.id && elem.hidden,
              disabled: this.state.value === elem.id && elem.hidden,
            };

            const cleanedElem = elem;

            delete cleanedElem.id;
            delete cleanedElem.name;
            delete cleanedElem.hidden;

            return {
              ...newElem,
              ...cleanedElem,
              discriminator: dict,
            };
          });
        data = data.concat(dictData);
      });
      let newState = { data: sortedDict(data, 'label') };

      if (!props.isChanged || props.updateDefValueOnEveryChange) {
        newState = { ...newState, value };
      }

      this.setState(newState);
    }
  }
  render() {
    return this.state.data ?
      (<div id={`${this.props.name}_select`}>
        <Modal bsSize="large" show={this.state.showModal} onHide={this.closeModal} >
          <Modal.Header>
            Error while adding new value to the Reference '{this.addButtonDictName()}'
          </Modal.Header>
          <Modal.Body>
            {this.state.errorMsg}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.closeModal}>Ok</Button>
          </Modal.Footer>
        </Modal>
        <Select
          id={this.props.name}
          disabled={this.props.disabled === undefined ? this.context.disabled : this.props.disabled}
          name={this.props.name}
          valueComponent={SelectValue}
          optionComponent={OptionComponent}
          options={this.state.data}
          onChange={this.onChange}
          value={this.state.value}
          filterOptions={this.filterOptions}
          multi={this.props.multi}
          onInputChange={this.onInputChange}
          backspaceToRemoveMessage=""
          openOnFocus={this.props.openOnFocus}
          matchProp="label"
          ref={(ref) => (this.props.onRef ? this.props.onRef(ref) : {})}
        />
      </div>)
      : <div></div>;
  }
}

MultiDictsPicker.propTypes = {
  simple: React.PropTypes.object,
  excludeData: React.PropTypes.oneOfType(
    [
      React.PropTypes.array,
      React.PropTypes.object,
    ]
  ),
  dicts: React.PropTypes.string,
  name: React.PropTypes.string,
  filterOptions: React.PropTypes.func,
  filterFunc: React.PropTypes.func,
  defaultValue: React.PropTypes.oneOfType(
    [
      React.PropTypes.object,
      React.PropTypes.array,
      React.PropTypes.number,
    ]
  ),
  onChangeFunc: React.PropTypes.func,
  disabled: React.PropTypes.bool,
  readonly: React.PropTypes.bool,
  multi: React.PropTypes.bool,
  handleFormChanged: React.PropTypes.func,
  openOnFocus: React.PropTypes.bool,
  onRef: React.PropTypes.func,
  putError: React.PropTypes.func,
  clearOnDisabledSwitch: React.PropTypes.bool,
  addButtonDict: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.object]),
  onBeforeAddDictValue: React.PropTypes.func,
  updateDefValueOnEveryChange: React.PropTypes.bool,
};

MultiDictsPicker.contextTypes = {
  disabled: React.PropTypes.bool,
};

const mapStateToProps = (state) => ({
  simple: state.getIn(['references', 'simple'], new Map()),
  isChanged: state.getIn(['allaround', 'formChanged'], false),
});

export default connect(mapStateToProps, (dispatch) => ({
  handleFormChanged() {
    handleFormChanged(dispatch);
  },
}))(MultiDictsPicker);
